const PropertyDetailNotFound = ({ onBack }) => (
  <div className="property-detail-state property-detail-state--not-found">
    <h2>Property not found</h2>
    <p>This listing may have been removed or is no longer available in Midpoint.</p>
    {onBack ? (
      <button type="button" className="midpoint-share-button" onClick={onBack}>
        Back to results
      </button>
    ) : null}
  </div>
);

export default PropertyDetailNotFound;
